import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader
import { Carousel } from "react-responsive-carousel";
import { Grid } from "@material-ui/core";
import "./carousel.css";
import data from "../data.json";

const useStyles = makeStyles({
  root: {
    flexGrow: 2,
    display: "flex",
    width: "100vw",
    justifyContent: "center",
    alignContent: "center",
  },
  header: {
    fontFamily: "Open Sans",
    fontSize: "28px",
    color: "#aaaaaa",
    textTransform: "uppercase",
    letterSpacing: "2px",
    paddingBottom: "0px",
    marginBottom: "0px",
    marginTop: "50px",
    textAlign: "center",
  },
  header2: {
    fontFamily: "Open Sans",
    fontSize: "15px",
    color: "#aaaaaa",
    textTransform: "uppercase",
    letterSpacing: "2px",
    paddingBottom: "4px",
    textAlign: "center",
    marginBottom: "30px",
  },
  linkStyle:{
    textDecoration: "underline",
    textDecorationColor: "#aaaaaa",
  }
});

const ImageCarousel = () => {
  const classes = useStyles();

  return (
    <div>
      <a className={classes.linkStyle} href='https://www.michigandaily.com/section/statement/visual-statement-intersections'>
        <h1 className={classes.header}>Visual Statement: Intersections</h1>
      </a>
      <h2 className={classes.header2}>By Jarett Orr</h2>

      <div className={classes.root}>
        <Grid justify="center" alignItems="center">
          <Grid item xs={12}>
            <Carousel
              className={classes.carousel}
              dynamicHeight={true}
              showThumbs={false}
              showIndicators={false}
              width="60vw"
            >
              {data.carouselImages.map((url) => {
                return (
                  <div>
                    <img alt="" src={url} />
                  </div>
                );
              })}
            </Carousel>
          </Grid>
        </Grid>
      </div>
    </div>
  );
};

export default ImageCarousel;
